import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function AuthorCredit() {
  const { t } = useTranslation();
  return (
    <Typography
      component="p"
      variant="caption"
      color="text.secondary"
      sx={{ mt: 'auto', pt: 4, pb: 3, px: 2, textAlign: 'center', opacity: 0.72, fontSize: { xs: '0.65rem', sm: '0.75rem' } }}
    >
      {t('common.madeBy')}
    </Typography>
  );
}
